
<template>
  <div>
    <!-- cadf43 -->
    <!-- 合作固定 -->
    <div ref="showimg" @click="showimg" class="showimg"><img src="@/assets/img/zuo343.png" alt=""></div>
    <div class="hezuo" ref="hezuoimg">
      <img @click="hideimg" class="closeopen" src="@/assets/img/shanchu44.png" alt="">
      <img @click="ishezuo = true,istijiao=false" class="zuodfr" src="@/assets/img/hezuo.png" alt="" />
    </div>

    <!--  ------------- -----------------------合作弹出框------------------------------------------ -->
    <div v-if="ishezuo" style="z-index: 99">
      <div class="popup_prompt">
        <div class="prompt_div" style="height: 159vw; top: 50%">
          <img @click="ishezuo = false" class="esc" src="@/assets/img/chacha.png" alt="" />
          <div class="title">
            <img src="@/assets/img/hezuodig.png" alt="" />
            <span>合作&建议</span>
          </div>
          <div class="text2">
            具体内容请填写以下信息，相关合作我们会与您取得联系
          </div>
          <div class="input1">
            <!-- <span>姓名</span> -->
            <input v-model="heform.name" type="text" placeholder="姓名" />
          </div>
          <div class="input1">
            <!-- @focus="hezuofocus"
                @blur="buluinput" -->
            <!-- <span>手机/微信</span> -->
            <input v-model="heform.concat" type="text" placeholder="手机/微信" />
          </div>
          <div class="input1" style="margin-bottom:0.1vw">
            <!-- <span>单位名称</span> -->
            <input v-model="heform.company" type="text" placeholder="单位名称" />
          </div>
          <!-- <div class="input133">
            <el-radio
              v-model="radio"
              :label="1"
            >合作</el-radio>
            <el-radio
              v-model="radio"
              :label="2"
            >建议</el-radio>
          </div> -->
          <!-- <div
            class="input2 input1"
            style=" margin-top:1vw"
          >
            <div>
            </div>
            <textarea
              v-show="radio===1"
              v-model="heform.content"
              id=""
              cols="30"
              rows="10"
              placeholder="请输入合作内容~"
            ></textarea>
            <textarea
              v-show="radio===2"
              v-model="heform.status"
              id=""
              cols="30"
              rows="10"
              placeholder="请输入您的建议~"
            ></textarea>
          </div> -->
          <div class="in33">
            <el-tabs type="border-card">
              <el-tab-pane label="合作">
                <div class="input2 " style=" margin-top:1vw">
                  <textarea v-model="heform.content" id="" cols="30" rows="10" placeholder="请输入合作内容~"></textarea>
                </div>
              </el-tab-pane>
              <el-tab-pane label="建议">
                <div class="input2 " style=" margin-top:1vw">
                  <textarea v-model="heform.status" id="" cols="30" rows="10" placeholder="请输入您的建议~"></textarea>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div @click="tijiaook12" class="tijao4">提交</div>
          <div class="qitahe">
            <div>
              <div class="teq1">其他方式</div>
              <div class="teq2">xuzhi@anesthesiavision.cn</div>
            </div>
            <img src="@/assets/img/gonhong1.png" alt="" />
          </div>
          <div class="butok2"></div>
        </div>
      </div>
    </div>
    <!--  ------------------------------------提交成功弹出框------------------------------------------ -->
    <div v-if="istijiao">
      <div class="popup_prompt">
        <div class="prompt_div" style="height: 109.6vw">
          <img @click="istijiao = false" class="esc" src="@/assets/img/chacha.png" alt="" />
          <div class="tijiaook">
            <img class="tiji1" src="@/assets/img/tijiaook.png" alt="" />
            <div class="tiji2">信息已提交成功</div>
            <div class="tiji3">
              相关合作我们将尽快与您取得联系，请您注意
              微信好友添加信息，保持电话畅通
            </div>
            <img class="tiji4" src="@/assets/img/thinkyou.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ishezuo: false,
      //   完成弹出
      istijiao: false,
      isshow: false,
      radio: 1,
      heform: {
        name: "",
        concat: "",
        company: "",
        content: "",
        type: 0,
        status: '',
        member_id: ''
      },
    };
  },

  components: {},

  computed: {},

  mounted: {
    // 完成提交弹窗

  },

  methods: {
    tijiaook12() {
      if (!this.heform.name.trim()) {
        this.$message.error("请填写 姓名 哦~");
      } else if (!this.heform.concat.trim()) {
        this.$message.error("请填写 手机/微信 哦~");
      } else if (!this.heform.company.trim()) {
        this.$message.error("请填写 单位名称 哦~");
      } else if (this.heform.content.trim() === '' && this.heform.status.trim() === '' || this.heform.status.trim() === '' && this.heform.content.trim() === '') {
        this.$message.error("请填写 合作/建议 哦~");
      } else {
        if (localStorage.getItem('USER_111')) {
          this.heform.member_id = JSON.parse(localStorage.getItem('USER_111')).id
          this.getpost()
        } else {
          this.heform.member_id = -1
          this.getpost()
        }
      }
    },
    getpost() {
      this.$post("concat", { ...this.heform }).then((res) => {
        if (res.code === 200) {
          this.ishezuo = false;
          this.istijiao = true;
          this.radio = 1
          this.heform = {
            name: "",
            concat: "",
            company: "",
            content: "",
            type: 0,
            status: '',
          }
        } else {
          this.$message.error("提交表单出错啦~");
        }
      });
    },
    hideimg() {
      this.$refs.hezuoimg.style.transform = "translateX(99px)"
      this.$refs.hezuoimg.style.opacity = "0"
      this.$refs.showimg.style.opacity = "1"
    },
    showimg() {
      this.$refs.hezuoimg.style.transform = "translateX(0px)"
      this.$refs.hezuoimg.style.opacity = "1"
      this.$refs.showimg.style.opacity = "0"

    }
  }
}

</script>
<style  scoped>
/deep/ .el-tabs--border-card {
  box-shadow: none;
  border-radius: 1vw;
  border: 0.3vw solid #cccccc;
}
/* 视频分类弹出框 */
.popup_prompt {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}
.prompt_div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 1vw;
  width: 88.27vw;
  height: 82.4vw;
  border-radius: 1vw 1vw 1vw 1vw;
  background: #f9f9f9;
}
.prompt_div .esc {
  width: 3.77vw;
  height: 3.77vw;
  position: absolute;
  top: 2.4vw;
  right: 2.4vw;
}
.prompt_div .title {
  width: 100%;
  height: 7.2vw;
  display: flex;
  margin-top: 3.47vw;
  justify-content: center;
}
.prompt_div .title img {
  width: 7.2vw;
  height: 7.2vw;
  object-fit: cover;
}
.prompt_div .title div {
  width: 7.2vw;
  height: 7.2vw;
  object-fit: cover;
}
.prompt_div .title span {
  font-size: 4.27vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 8.07vw;
  color: #333333;
  opacity: 1;
}
.prompt_div .catelist {
  padding: 5.33vw 7.5vw;
  height: 63vw;
  overflow: scroll;
}
.prompt_div .cateitem {
  float: left;
  width: 33.33vw;
  height: 9.07vw;
  background: #ffffff;
  box-shadow: 0vw 1vw 1vw rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 1vw;
  font-size: 3.2vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  text-align: center;
  line-height: 9.07vw;
  margin-bottom: 4.5vw;
}
.activecate1 {
  background: #51a3ff !important;
  color: #fff !important;
}
.prompt_div .cateitem img {
  width: 2.98vw;
  height: 3.01vw;
}
.prompt_div .cateitem:nth-child(2n) {
  margin-left: 5.2vw;
}
.butok2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 9vw;
  line-height: 9vw;
  border-radius: 0vw 0vw 1vw 1vw;
  background: #2a2a2a;
  text-align: center;
  font-size: 3.2vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
}

/* 合作弹出 */
.text2 {
  width: 76.53vw;
  height: 8.53vw;
  font-size: 3.73vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  opacity: 1;
  margin: auto;
  /* text-align: center; */
}
.prompt_div .input1 {
  width: 77.87vw;
  height: 8.27vw;
  line-height: 8.27vw;
  background: #ffffff;
  border: 0.3vw solid #cccccc;
  opacity: 1;
  border-radius: 1vw;
  margin: auto;
  margin-top: 3.2vw;
  padding-left: 10px;
}
.input133 {
  width: 77.87vw;
  height: 8.27vw;
  line-height: 8.27vw;
  opacity: 1;
  border-radius: 1vw;
  margin: auto;
  margin-top: 1.2vw;
  padding-left: 0px;
}
.in33 {
  width: 80.87vw;
  opacity: 1;
  border-radius: 1vw;
  margin: auto;
  margin-top: 1.2vw;
  padding-left: 0px;
  overflow: hidden;
}
.prompt_div .input1 span {
  width: 7.47vw;
  height: 3.73vw;
  font-size: 3.73vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  opacity: 1;
  padding: 0px 2.93vw;
}
.prompt_div .input1 input {
  width: 97%;
}
.prompt_div .input2 {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 26.93vw;
  background: #ffffff;
  border: 0.3vw solid #cccccc;
  opacity: 1;
  border-radius: 1vw;
  margin: auto;
  margin-top: 3.2vw;
}
.prompt_div .input2 textarea {
  width: 100%;
  height: 80%;
  border: 0;
  outline: 0;
  padding: 2vw 10px;
}
.tijao4 {
  width: 77.33vw;
  height: 9.33vw;
  line-height: 9.33vw;
  background: linear-gradient(90deg, #5eb1ff 0%, #0c57fe 100%);
  opacity: 1;
  border-radius: 5vw;
  font-size: 3.73vw;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  margin: auto;
  margin-top: 3.7vw;
}
.qitahe {
  width: 77.33vw;
  height: 27.2vw;
  margin: auto;
  display: flex;
  justify-content: space-around;
  margin-top: 4vw;
}
.qitahe div {
  font-size: 3.2vw;
  font-family: Source Han Sans CN;
}
.qitahe img {
  width: 27.2vw;
  height: 27.2vw;
  object-fit: cover;
}
.teq1 {
  width: 14.53vw;
  height: 3.2vw;
  padding-top: 7.2vw;
  margin: auto;
  color: #333333;
}
.teq2 {
  width: 40.4vw;
  height: 3.47vw;
  padding-top: 7vw;
  margin: auto;
  color: #999999;
}

/* 提交成功 */
.tijiaook {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tiji1 {
  margin-top: 14.13vw;
  width: 14.13vw;
  height: 14.13vw;
  object-fit: cover;
}
.tiji2 {
  margin-top: 3.13vw;
  width: 31.33vw;
  height: 4.27vw;
  font-size: 4.27vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
}
.tiji3 {
  margin-top: 6.67vw;
  width: 60.13vw;
  height: 9.07vw;
  font-size: 3.73vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  opacity: 1;
}
.tiji4 {
  margin-top: 4.8vw;
  width: 37.87vw;
  height: 37.87vw;
  object-fit: contain;
}
.hezuo {
  width: 11.07vw;
  position: fixed;
  bottom: 19vw;
  right: 5vw;
  z-index: 99;
  transition: all 1s;
  text-align: right;
}
.hezuo .zuodfr {
  width: 11.07vw;
}
.showimg {
  width: 8vw;
  height: 9vw;
  line-height: 9vw;
  position: fixed;
  bottom: 23vw;
  right: -4vw;
  z-index: 99;
  background-color: #fd6b6d;
  border-radius: 50%;
  transition: all 0.5s;
  opacity: 0;
}
.showimg img {
  width: 4vw;
}
.closeopen {
  width: 4vw;
}
</style>


// WEBPACK FOOTER //
// src/components/tool/m_hezuo.vue